import { render } from "@/components/pages/soldInformationMain/SoldInformationMain.html?vue&type=template&id=481c4c23&external"
import script from "@/components/pages/soldInformationMain/SoldInformationMain.js?vue&type=script&lang=js&external"
export * from "@/components/pages/soldInformationMain/SoldInformationMain.js?vue&type=script&lang=js&external"

import "@/components/pages/soldInformationMain/SoldInformationMain.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__